/**
 * report-viewer.component.ts
 *
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.33.0 OAUI-481 The reports exports are no longer working
 * 4.31.0 OAUI-455 Add basic table to display orders
 * 4.26.0 OAUI-418 Hook up API calls for QR Code Order Management page
 * 4.26.0 OAUI-416 Add basic QR code order management route
 * 4.22.0 OAUI-390 Billing Report: build Angular UI
 *
 * @author Luis Hernandez <lhernandez@intersog.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2023 Build Centrix
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { WdWorkOrderReportService } from '../../services/orders/reports/wd-work-order-report.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-report-viewer',
  templateUrl: './report-viewer.component.html',
  styleUrls: ['./report-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportViewerComponent implements OnInit {
  debug: boolean | undefined = false;

  report: SafeHtml | undefined;

  // Subscriptions
  subscriptions = new Subscription();

  constructor(
    private workOrderService: WdWorkOrderReportService,
    private sanitizer: DomSanitizer,
    public activatedRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
  ) {}

  /**
   * On Init
   *
   * @since 4.63.0
   *
   */
  ngOnInit() {
    this.watchForRouteChange();
  }

  /**
   * Subscribe to current route
   *
   * @since 4.63.0
   *
   */
  private watchForRouteChange(): void {
    // Subscribe to Route Change
    const routeSubscription = this.activatedRoute.params.subscribe(
      async (params) => {
        const { orderIndex, type } = params;
        await this.updateWorkOrder(orderIndex, type);
      },
    );
    this.subscriptions.add(routeSubscription);
  }

  /**
   * Update report based on parameters
   *
   * @since 4.63.0
   *
   * @memberof ManageComponent
   */
  private updateWorkOrder(workOrderIndex: string, type: string) {
    this.workOrderService
      .getWorkOrderReportByIndex(workOrderIndex, type, {
        debug: this.debug,
        format: 'html',
      })
      .then((report) => {
        if (workOrderIndex && type && report) {
          this.report = this.sanitizer.bypassSecurityTrustHtml(report);
        }
        this.changeDetector.markForCheck();
      });
  }
}
